



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CompanyDocument, User } from '../store/models';
import * as api from '@/store/api';

@Component
export default class UserSelection extends Vue {
  @Prop() readonly excluded!: string[];

  usersRaw: User[] | null = null;
  selectedUser: string = '';
  searchText: string = '';
  users: any = [];

  async mounted() {
    this.usersRaw = await api.getUsers();
  }

  filter(options: any, search: any) {
    this.searchText = search.toLowerCase();
    return options;
  }

  @Watch('searchText')
  onSearch() {
    if (this.searchText.length < 1) {
      this.users = [];
      return;
    }
    if (!this.usersRaw) {
      this.users = [];
      return;
    }
    const res: any = [];
    for (const u of this.usersRaw) {
      if (this.excluded && this.excluded.includes(u.UserId)) {
        continue;
      }
      const s = `${u.FirstName} ${u.LastName} ${u.Locality}`;
      if (s.toLowerCase().indexOf(this.searchText) !== -1) {
        res.push({
          value: u.UserId,
          label: `${u.FirstName} ${u.LastName} (${u.Locality})`,
        });
      }
    }
    // for (let i = 0; i < 20; i++) {
    //     res.push({
    //         value: 'user' + i,
    //         label: 'user' + i,
    //     });
    // }
    res.sort((a: any, b: any) => {
      return ('' + a.label).localeCompare(b.label);
    });
    this.users = res;
  }
}
